import { captureMessage } from '@sentry/nextjs';
import axios from 'axios';
import { TestConfig } from 'pages/api/ab-tests';

const AB_TESTS_ENDPOINT = '/api/ab-tests';

/**
 * Fetches AB test configurations by their IDs
 * @param ids - Array of AB test IDs to fetch
 * @returns Promise containing a record of test IDs to their configurations
 */
export const getAbTests = async ({
  ids,
  contentfulEnv,
  contentfulSpace,
}: {
  ids: string[];
  contentfulEnv: string;
  contentfulSpace: string;
}): Promise<Record<string, TestConfig>> => {
  try {
    const { data } = await axios.post<Record<string, TestConfig>>(AB_TESTS_ENDPOINT, {
      ids,
      contentfulEnv,
      contentfulSpace,
    });
    return data;
  } catch (error) {
    captureMessage('Failed to fetch AB tests', {
      level: 'error',
      extra: {
        ids,
        contentfulEnv,
        contentfulSpace,
      },
    });
    return {};
  }
};
